import React from "react";
import FantasyOverviewTable from "../FantasyOverviewTable";
import FantasyDriverTable from "../FantasyDriverTable";
import FantasyAdvancedTab from "../FantasyAdvancedTab";
import FantasyConsistencyTable from "../FantasyConsistencyTable";
import FantasyRankingTable from "../FantasyRankingTable";

export const renderSelectedFantasyTable = (selectedTable, tableProps) => {
  switch (selectedTable) {
    case "overview":
      return <FantasyOverviewTable {...tableProps} />;
    case "finish":
      return <FantasyDriverTable {...tableProps} feature="race_pos" name="Finish Position" />;
    case "start":
      return <FantasyDriverTable {...tableProps} feature="quali_pos" name="Qualification Position" />;
    case "points":
      return <FantasyDriverTable {...tableProps} feature="fantasy_points" name="Fantasy Points" />;
    case "rating":
      return <FantasyDriverTable {...tableProps} feature="driver_rating" name="Rating" />;
    case "advanced":
      return <FantasyAdvancedTab {...tableProps} />;
    case "ranking":
      return <FantasyRankingTable {...tableProps} />;
    case "consistency":
      return <FantasyConsistencyTable {...tableProps} />;
    default:
      return null;
  }
};
